(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.customerSelector', [])

        .directive('newOrderCustomerSelector', function () {
            return {
                restrict: "E",
                templateUrl: 'app/ui/order/newOrderView/newOrderCustomerSelector/newOrderCustomerSelector.html',
                scope: {
                    selectedCustomerId: "=customerId",
                    deliveryAddress: "="
                },
                controller: 'NewOrderCustomerSelectorController'
            };
        })

        .controller('NewOrderCustomerSelectorController', function ($scope,
                                                                    newOrderAddressService, newOrderListService, customersRepository, usersRepository) {

            angular.extend($scope, {
                isCustomersListDisabled: isCustomersListDisabled
            });

            $scope.customers = [];

            initCustomersListOptions();
            initCustomers();

            function initCustomers() {
                $scope.customers = [];
                usersRepository.getCurrentUser()
                    .then(function (user) {
                        if (user.isCentre()) {
                            customersRepository.getCustomers()
                                .then(function (customers) {
                                    setCustomers(customers);
                                });
                        } else if (user.isCustomer()) {
                            setCustomers(user.$model.customers);
                        }
                    });
            }

            function setCustomers(customers) {
                $scope.customers = customers || [];

                _.each($scope.customers,
                    function(customer) {
                        customer.title = newOrderAddressService.getCustomerTitle(customer.$model);
                    });

                if ($scope.customers.length === 1) {
                    $scope.selectedCustomerId = $scope.customers[0].$model.id;
                }

                updateCustomersList();
            }

            function isCustomersListDisabled() {
                var addressEditMode = $scope.selectedCustomerId && !$scope.deliveryAddress;
                var lackOfCustomers = $scope.customers.length < 2;

                return addressEditMode || lackOfCustomers;
            }

            function initCustomersListOptions() {
                var getCustomers = function () {
                    return $scope.customers;
                };
                var customerTemplate = "<span>{{dataItem.title}}</span>";
                $scope.customersListOptions = newOrderListService.getListOptions(getCustomers, customerTemplate, "$model.id");
            }

            function updateCustomersList() {
                var selectedCustomerId = $scope.selectedCustomerId;
                newOrderListService.updateList($scope.customersList);
                if ($scope.selectedCustomerId !== selectedCustomerId) {
                    $scope.selectedCustomerId = selectedCustomerId;
                }
            }
        })
    ;
})(window.angular);
